import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { SectorsAndIndustriesPageDataService } from "../sectors-and-industries-page-data-service";

@Component({
  selector: "app-sectors-and-industries-page",
  templateUrl: "./sectors-and-industries-page.component.html",
  styleUrls: ["./sectors-and-industries-page.component.scss"],
  host: { class: "sectors-industries-page-component" },
})
export class SectorsAndIndustriesPageComponent implements OnInit {
  assets = environment.assetUrl;
  sectorMetaDta = {};
  sectorMetaReady = false;
  hasCompsAccess = false;
  constructor(private dataService: SectorsAndIndustriesPageDataService) {}

  ngOnInit() {
    this.dataService.getSectorMeta().subscribe((data) => {
      this.hasCompsAccess = data.va_comps_accessible;
      data.sectors.forEach((sector) => {
        this.sectorMetaDta[sector["sector_id"]] = sector;
      });
      this.sectorMetaReady = true;
    });
  }
}
